'use strict';

DoohApps
.directive('validDate', ['$filter', '$window', '$parse', function ($filter, $window, $parse) {
    return {
        require: '?ngModel',
        restrict: 'A',
        compile: function () {
            var getter, setter;
            return function (scope, element, attrs, ngModel) {
                //Declaring the getter and setter
                getter = $parse(attrs.ngModel);
                setter = getter.assign;
                //Set the initial value to the View and the Model
                ngModel.$formatters.unshift(function (modelValue) {
                    if (!modelValue) return '';
                    var retVal = $filter('date')(modelValue, 'yyyy-MM-dd');
                    setter(scope, retVal);
                    return retVal;
                });
            };
        }
    };
}]);